
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/motorcycles",
      function () {
        return require("private-next-pages/products/motorcycles/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/motorcycles"])
      });
    }
  